import {
  SET_PHOTOSWIPE_OPEN,
  SET_PHOTOSWIPE_INDEX,
  SET_PHOTOSWIPE_MOMENT,
  SET_PHOTOSWIPE_ITEMS
} from 'shared/actions/types';

export const setPhotoSwipeOpen = isOpen => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_OPEN,
    payload: isOpen
  });

  return Promise.resolve();
}

export const setPhotoSwipeIndex = index => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_INDEX,
    payload: index
  });

  return Promise.resolve();
}

export const setPhotoSwipeMoment = moment => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_MOMENT,
    payload: moment
  });

  return Promise.resolve();
}

export const setPhotoSwipeItems = items => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_ITEMS,
    payload: items
  });

  return Promise.resolve();
}
